export default __webpack_public_path__ + "static/hubspot-form-builder-looping-717341db548040c04db9f17cdfde7387.mp4";